// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__0IUN1","active":"MainHeader_active__dLT-e","dropdown":"MainHeader_dropdown__QTCN+"};